import {array, number, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {localizedTextRequired} from '@shared/utils';

const voucherCurrencyAmountV8nSchema = object().shape({
  currency: string().required(),
  amount: number().integer().positive().required(),
});

const voucherRewardV8nSchema = object().shape({
  id: string().required(),
  reward_kind: string().oneOf(['voucher']).required(),
  currencies: array().of(voucherCurrencyAmountV8nSchema).required(),
  voucher_ttl_days: number().integer().positive().nullable().defined(),
});

export const voucherConfigV8nSchema = voucherRewardV8nSchema.shape({
  title: string().defined(),
});

export const voucherConfigDetailsV8nSchema = voucherRewardV8nSchema.shape({
  name: localizedTextRequired,
});

export const v8nSchemaOfGetVoucherConfigsResponse = paginationV8nSchema.shape({
  array: array().of(voucherConfigV8nSchema).required(),
});
